import { PolarisCheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/extensions/PolarisCheckoutExtensionsUI';

/**
 * Single source of truth for the Shopify Polaris checkout spacing scale
 * (`paddingBlockStart` tokens, Polaris web components 2026-01+), shared by
 * every checkout extension.
 */

export type PolarisPaddingToken = PolarisCheckoutExtensionUI.Padding | '';

export interface PolarisPaddingStep {
  label: string;
  value: PolarisPaddingToken;
  px: string;
}

const Padding = PolarisCheckoutExtensionUI.Padding;

export const POLARIS_PADDING_SCALE: readonly PolarisPaddingStep[] = [
  { label: 'None', value: '', px: '0' },
  { label: 'Small 500', value: Padding.SMALL_500, px: '2px' },
  { label: 'Small 400', value: Padding.SMALL_400, px: '4px' },
  { label: 'Small 300', value: Padding.SMALL_300, px: '6px' },
  { label: 'Small 200', value: Padding.SMALL_200, px: '8px' },
  { label: 'Small 100', value: Padding.SMALL_100, px: '10px' },
  { label: 'Small', value: Padding.SMALL, px: '10px' },
  { label: 'Base', value: Padding.BASE, px: '14px' },
  { label: 'Large', value: Padding.LARGE, px: '16px' },
  { label: 'Large 100', value: Padding.LARGE_100, px: '16px' },
  { label: 'Large 200', value: Padding.LARGE_200, px: '20px' },
  { label: 'Large 300', value: Padding.LARGE_300, px: '24px' },
  { label: 'Large 400', value: Padding.LARGE_400, px: '32px' },
  { label: 'Large 500', value: Padding.LARGE_500, px: '40px' },
];

// Dropdown options for admin controls (label + token value), derived from the scale.
export const POLARIS_PADDING_OPTIONS: { label: string; value: string }[] = POLARIS_PADDING_SCALE.map(
  ({ label, value }) => ({ label, value }),
);

const PX_BY_TOKEN = new Map<string, string>(POLARIS_PADDING_SCALE.map((step) => [step.value, step.px]));

/** Resolves a Polaris padding token to its live-preview px; unknown/empty → `0`. */
export function polarisPaddingToSpacing(token: string | undefined): string {
  return PX_BY_TOKEN.get(token ?? '') ?? '0';
}
